import { Component, EventEmitter, Injector, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BodyComponentObject, TemplateMessageObject, TemplateMessageObjectPager } from '@trendbuild/trend-cloud-api';
import { AbstractComponent, Channel, ChannelService } from 'lib-trend-core';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'webhook-integration-wa-template',
    // templateUrl: './webhook-integrations-wa-template.component.html',
    templateUrl: './webhook-integrations-wa-template.v2.component.html',
    styleUrls: ['./webhook-integrations-wa-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebhookWaTemplateComponent extends AbstractComponent {

  @Input() set channel(channel: Channel) {
    this.selectedChannel = channel;
    this.getList();
  }

  @Output() onSelectTemplate = new EventEmitter<TemplateMessageObject>();

  selectedTemplate: TemplateMessageObject = null
  templates: Array<TemplateMessageObject> = new Array<TemplateMessageObject>()
  selectedChannel: Channel


  constructor(injector: Injector, private channelService: ChannelService) {
    super(injector);
  }

  async getList() {
    if (!this.selectedChannel) return

    const requestedChannelId = this.selectedChannel._id;

    this.channelService.getTemplatesByChannel(requestedChannelId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (templateMessageObjectPager: TemplateMessageObjectPager) => {
          if (requestedChannelId !== this.selectedChannel?._id) {
            return;
          }
          this.templates = templateMessageObjectPager.data ?? [];
        },
        error: (err) => {
          if (requestedChannelId !== this.selectedChannel?._id) {
            return;
          }
          this.templates = [];
          this.alertService.error(err?.error?.message);
        }
      });
  }

  showTemplateDetails(template: TemplateMessageObject) {
    this.onSelectTemplate.emit(template)
  }

  getBodyText(template: TemplateMessageObject): string {
    const bodyComponent = <BodyComponentObject>template?.components.find(c => c.type === 'BODY');
    return bodyComponent.text;
  }

}
